import {useState, useEffect} from 'react'
import { useParams } from "react-router"
import RelationList from '../../RelationList'
import EditContentSetting from './EditContentSetting'
import AddContentSetting from './AddContentSetting'
import ContentModelRelation from './ContentModelRelation'
import './dcm.css'
import {DndContext, DragOverlay,MouseSensor,TouchSensor,useSensor,useSensors} from '@dnd-kit/core';
import {arrayMove, SortableContext,useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';

const EditContentModel = ({language, setBreadcrumbObject}) => {
    let { contentModelId } = useParams();
    const [contentModel, setContentModel] = useState()
    const [contentSettings, setContentSettings] = useState([])
    const [contentTypes, setContentTypes] = useState()
    const [editContentSettingId, setEditContentSettingId] = useState()
    const [showEditContentSetting, setShowEditContentSetting] = useState(false)
    const [showAddContentSetting, setShowAddContentSetting] = useState(false)
    const [overItemId, setOverItemId] = useState()
    const [dragDirection, setDragDirection] = useState()
    const [deleteContentSetting, setDeleteContentSetting] = useState(undefined)

    const [activeId, setActiveId] = useState(undefined);
    const getPosition = (id) => contentSettings.findIndex(r=>r.id === id);
    const sensors = useSensors(
        useSensor(MouseSensor, {
          // Require the mouse to move by 10 pixels before activating
          activationConstraint: {
            distance: 10,
          },
        }),
        useSensor(TouchSensor, {
          // Press delay of 250ms, with tolerance of 5px of movement
          activationConstraint: {
            delay: 250,
            tolerance: 5,
          },
        }))

        const postContentSettingSortOrder = async (settingId, sortOrder) => {

          var graphql = JSON.stringify({
              query: `mutation ($settingId: Long, $sortOrder: Long){
                          putContentSettingSortOrder(settingId:$settingId, sortOrder:$sortOrder) {
                            id
                            sortOrder
                          }
                      }`,
              variables: {
                  "settingId": settingId
                  ,"sortOrder": sortOrder
              }
              
            })
          const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
              method:'POST',
              headers:{
                  'Authorization':'Basic ' + global.config.Editor.authToken
                  ,'Content-Type': 'application/json'
              },
              body: graphql
          })
          .then(response => response.text())
          .then(result => {
              var resultData = JSON.parse(result).data
              //if(resultData.addContentType){
              //    history.push(`/content/${resultData.addContentType.id}`)
              //}
              return 
          })
          .catch(error => console.log('error', error))
          const data = await res
          
          return data
  
      }

      const handleConfirm = async (yesNo) => {
          if(yesNo){
            postDeleteContentSetting()
          }else{
              setDeleteContentSetting()
          }
      }

      const postDeleteContentSetting = async () => {

        var graphql = JSON.stringify({
            query: `mutation ($settingId: Long, $contentModelId: Long){
                        deleteContentSetting(settingId:$settingId, contentModelId:$contentModelId) {
                            id
                            contentModelId
                            settingAlias
                            settingName
                            settingType
                            defaultValue
                            settingDescription
                            showDescription
                            sortOrder
                        }
                    }`,
            variables: {
                "settingId": deleteContentSetting.id
                ,"contentModelId": contentModelId
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            
            setContentSettings(resultData.deleteContentSetting)
            setDeleteContentSetting()
            return 
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data

    }

    const fetchContentModel = async () => {

        var graphql = JSON.stringify({
            query: `query {
                        contentModel(id:${contentModelId}) {
                            id
                            modelName

                            editors{
                                id
                                editorName
                                editorEmail
                            }
                        }
                        contentSettings( contentModelId:${contentModelId}){
                            id
                            contentModelId
                            settingAlias
                            settingName
                            settingType
                            defaultValue
                            settingDescription
                            showDescription
                            sortOrder
                        }
                        contentTypes( contentModelId:${contentModelId}){
                            id
                            contentTypeName
                        }
                    }`,
            variables: {}
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {return JSON.parse(result).data})
        .catch(error => console.log('error', error))
        const data = await res
        return data

    }

    useEffect(() => {
        const getContentModel = async () => {
            const data = await fetchContentModel()
            setContentModel(data.contentModel)
            setContentSettings(data.contentSettings)
            setContentTypes(data.contentTypes)
            
                setBreadcrumbObject({type: language.value === "DA" ? "Indholds model: " : "Content model: ", name: data.contentModel.modelName, link: '', linkText: ''})
            
        }
        getContentModel()

    },[contentModelId])


    const handleShowAddContentSetting = async e => {
        e.preventDefault();
        setShowAddContentSetting(showAddContentSetting ? false : true)
    }

    const handleShowEditContentSetting = (settingId) => {
        setEditContentSettingId(settingId)
        setShowEditContentSetting(showEditContentSetting ? false : true)
    }

    const handleShowRelationSelect = (setting) => {

    }

    let content;

    if (contentModel && contentSettings && contentTypes) {
        content = (
            <div id="cc_setting_editcontainer">
                <div id="cc_setting_list" className="cc_item_list">

                    <label className="list-header">
                        <span className="checkbox-container">&nbsp;</span>
                        <span className="name-container">{language.value === "DA" ? "Navn" : "Name"}</span>
                        <span className="type-container">{language.value === "DA" ? "Type" : "Type"}</span>
                        <span className="published-container">{language.value === "DA" ? "Alias" : "Alias"}</span>
                        <span className="edit-container">
                            &nbsp;
                        </span>
                    </label>
                    {(contentSettings) &&
                    <DndContext sensors={sensors} onDragStart={handleDragStart} onDragEnd={handleDragEnd} onDragOver={handleDragOver}>
                        <SortableContext items={contentSettings}>
                            {
                                contentSettings.map((setting, index) => (
                                    <SortableItem key={setting.id} 
                                                id={setting.id} 
                                                setting={setting} 
                                                index={index} 
                                                setDeleteContentSetting={setDeleteContentSetting}
                                                className={`${(activeId && overItemId && overItemId === setting.id) && 'draggable-' + dragDirection} ${(activeId && activeId.id === setting.id) && 'draggable-dragging'}`} />
                                ))
                            }
                            
                        </SortableContext>
                        <DragOverlay>
                            {activeId ? (
                            <div>
                                <label key={activeId.id} className="list-item">
                                    <span className="checkbox-container">
                                        {(activeId.settingType === 'string') && <i className="sprite-icon icon-string"></i>}
                                        {(activeId.settingType === 'bool') && <i className="sprite-icon icon-checked"></i>}
                                        {(activeId.settingType === 'rte') && <i className="sprite-icon icon-edit"></i>}
                                    </span>
                                    <span className="name-container">{activeId.settingName}</span>
                                    <span className="type-container">{activeId.settingType}</span>
                                    <span className="published-container">{activeId.settingAlias}</span>
                                    <span className="edit-container">&nbsp;</span>
                                </label>
                            </div> 
                            ): null}
                        </DragOverlay>
                    </DndContext>
                    }
                    <div className="txt-center">
                        <span className="add-btn-round" onClick={handleShowAddContentSetting}>
                            <i className="sprite-icon icon-plus"></i>
                        </span>
                    </div>
                </div>
                <div id="cc_info_panel">
                    <RelationList contentTypes={contentTypes} language={language} heading={language.value === "DA" ? "Artikler" : "Articles"} />
                    {
                        (contentModel.editors) && 
                        <> 
                        <h3>{language.value === "DA" ? "Redaktører" : "Editors"}</h3>
                        {
                        contentModel.editors.map((editor) => (
                            <div>
                                <span>{editor.editorName}</span>  
                            </div>
                        ))
                        }
                        </>
                    }
                </div>
                <EditContentSetting isVisible={showEditContentSetting}
                                    setIsVisible={setShowEditContentSetting} 
                                    language={language} 
                                    setting={contentSettings.filter((setting)=> setting.id === editContentSettingId)[0]}
                                    contentSettings={contentSettings}
                                    setContentSettings={setContentSettings}/>
                <AddContentSetting isVisible={showAddContentSetting} 
                                    setIsVisible={setShowAddContentSetting}
                                    language={language} 
                                    contentModelId={contentModelId}
                                    contentSettings={contentSettings}
                                    setContentSettings={setContentSettings}/>
                {(deleteContentSetting) && 
                    <>
                    <div id="cc_overlay"></div>
                    <div className="cc-confirm-box">
                        <h3>{language.value === "DA" ? "Slet indholds type " : "Delete setting type"}</h3>
                        <p>
                            {language.value === "DA" ? "Vil du slette" : "Do you want to delete"}: <b>{deleteContentSetting.settingName}</b>
                        </p>
                        <div>
                            <button onClick={()=> handleConfirm(true)} className="cc-btn green-gradient">{language.value === "DA" ? "Ja" : "Yes"}</button>
                            <button onClick={()=> handleConfirm(false)} className="cc-btn red-gradient right">{language.value === "DA" ? "Nej" : "No"}</button>
                        </div>
                    </div>
                    </>
                }
            </div>
        );
      }


      function handleDragStart(event) {
        let value = contentSettings.find(x => x.id === event.active.id)
        setActiveId(value);
      }

      function handleDragOver(event) {
          if(event.draggingRect && event.over){
              if(event.draggingRect.top > event.over.rect.offsetTop){
                  setDragDirection('over')
              }else{
                setDragDirection('under')
              }
          }
          if(event.over){
            setOverItemId(event.over.id)
          }
      }
    function handleDragEnd(event) {
        const {active, over} = event;
        try{
            if (active.id !== over.id) {
              const oldIndex = getPosition(active.id);
              const newIndex = getPosition(over.id);
              setContentSettings((contentSettings) => {
                    return arrayMove(contentSettings, oldIndex, newIndex);
                });
                postContentSettingSortOrder(active.id, newIndex + 1)
            }
        }catch(err){}
        setActiveId()
        setOverItemId()
    }

    function SortableItem({id, setting, index, className, setDeleteContentSetting}) {
      const {attributes,listeners,setNodeRef,transform,transition,} = useSortable({id: id, setting: setting, index: index});
      const cssClass = className
      const style = {transform: CSS.Transform.toString(transform),transition,};
      
        const handleDelete = () => {
            console.log(setting) 
            setDeleteContentSetting(setting)
        }

      return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={cssClass}>
          <label key={setting.id} className="list-item">
                <span className="checkbox-container">
                    {(setting.settingType === 'string') && <i className="sprite-icon icon-string"></i>}
                    {(setting.settingType === 'bool') && <i className="sprite-icon icon-checked"></i>}
                    {(setting.settingType === 'rte') && <i className="sprite-icon icon-edit"></i>}
                </span>
                <span className="name-container">{setting.settingName}</span>
                <span className="type-container">{setting.settingType}</span>
                <span className="published-container">{setting.settingAlias}</span>
                <span className="edit-container">
                    {(setting.settingType === 'relation') && <i className="sprite-icon icon-menu" title={language.value === "DA" ? "Relationer" : "Relations"} onClick={() => handleShowRelationSelect(setting)}></i>}
                    <i className="sprite-icon icon-bin" title={language.value === "DA" ? "Slet" : "Delete"} onClick={handleDelete}></i>
                    <i className="sprite-icon icon-edit" title={language.value === "DA" ? "Rediger" : "Edit"} onClick={() => handleShowEditContentSetting(setting.id)}></i>
                </span>
            </label>
        </div>
      );
    }

    return (
        <>
            {content}
        </>
    )
}

export default EditContentModel
